/** @file copyBrief: copies the art brief to the clipboard, or downloads art-brief.md when that is refused. */
import type { EditorStore } from '../../state/editorTypes';
import type { BriefInput } from './artTypes';
import { briefTextOf } from './briefTextOf';
import { downloadBrief } from './downloadBrief';

/** Copies the brief and toasts `Art brief copied: N slots`; without clipboard access it downloads the file instead. */
export async function copyBrief(store: EditorStore, input: BriefInput): Promise<void> {
  const s = store.getState();
  const puppet = s.puppet.doc?.puppet;
  if (puppet === undefined) return;
  const { text, slots, unit } = briefTextOf(puppet, input.views, input.style, input.includeFilled, input.mode);
  try {
    await navigator.clipboard.writeText(text);
    s.notify('info', `Art brief copied: ${String(slots)} ${unit}`);
  } catch {
    downloadBrief(store, input);
    s.notify('warning', 'The clipboard is not available: art-brief.md was downloaded instead');
  }
}
